<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script>
    export default {
        name: 'expand-transition',

        methods: {
            enter(element) {
                const width = getComputedStyle(element).width;

                element.style.width = width;
                element.style.position = 'absolute';
                element.style.visibility = 'hidden';
                element.style.height = 'auto';

                const height = getComputedStyle(element).height;

                element.style.width = '';
                element.style.position = '';
                element.style.visibility = '';
                element.style.height = 0;

                getComputedStyle(element).height;

                requestAnimationFrame(() => {
                    element.style.height = height;
                });
            },

            afterEnter(element) {
                element.style.height = 'auto';
            },

            leave(element) {
                const height = getComputedStyle(element).height;
                element.style.height = height;

                getComputedStyle(element).height;

                requestAnimationFrame(() => {
                    element.style.height = 0;
                });
            },
        },
    };
</script>

<template>
    <transition
        v-bind="$attrs"
        name="transition-expand"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
    >
        <slot/>
    </transition>
</template>

<style scoped>
* {
  will-change: height;
  transform: translateZ(0);
  backface-visibility: hidden;
  perspective: 1000px;
}
</style>

<style lang="scss">
@use "@/scss/framework" as *;

.transition-expand {

    &-enter-active {
        transition: height var(--duration-appear) var(--easing-default);
        overflow: hidden;
    }

    &-leave-active {
        transition: height var(--duration-disappear) var(--easing-default);
        overflow: hidden;
    }

    &-enter,
    &-leave-to {
        height: 0;
    }
}

</style>
